import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Users, ArrowRight, Loader2 } from "lucide-react";
import api from "../lib/api";
import { toast } from "sonner";

// Beacon builder panel: turn on the private community (Beacon Hearth), pick a mode, open it.
export const BeaconHearthPanel = () => {
  const nav = useNavigate();
  const [state, setState] = useState(null);
  const [mode, setMode] = useState("invite");
  const [title, setTitle] = useState("");
  const [busy, setBusy] = useState(false);

  const load = async () => {
    try { const { data } = await api.get("/beacon/hearth"); setState(data); if (data.hearth) { setMode(data.hearth.mode); setTitle(data.hearth.title || ""); } }
    catch { /* noop */ }
  };
  useEffect(() => { load(); }, []);

  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/beacon/hearth", { mode, title: title || "Community", enabled: true });
      toast.success(state?.hearth ? "Community updated" : "Community turned on");
      await load();
      if (!state?.hearth && data.hearth_id) nav(`/hearth/${data.hearth_id}`);
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
    finally { setBusy(false); }
  };

  if (!state || !state.has_beacon) return null;
  const h = state.hearth;

  return (
    <div className="border border-white/10 bg-[#121212] p-5 mb-6" data-testid="beacon-hearth-panel">
      <h2 className="font-body text-lg text-white flex items-center gap-2 mb-1"><Lock size={17} className="text-[#14A89A]" /> Beacon Hearth: your private community</h2>
      <p className="font-body text-xs text-zinc-500 mb-4">A private, encrypted space attached to your Beacon, for subscribers, or invite family &amp; friends. Included on every hosting tier, no member limit.</p>

      {h ? (
        <div className="flex items-center justify-between flex-wrap gap-3">
          <div className="flex items-center gap-2 text-sm text-zinc-300 font-body"><Users size={15} className="text-[#14A89A]" /> <span className="text-white">{h.title}</span> · {h.member_count} member{h.member_count === 1 ? "" : "s"} · <span className="capitalize">{h.mode === "subscriber" ? "Open to subscribers" : "Invite-only"}</span></div>
          <button onClick={() => nav(`/hearth/${h.id}`)} data-testid="open-hearth" className="flex items-center gap-1.5 bg-[#14A89A] text-[#0A0A0A] font-semibold px-4 py-2 font-body text-xs">Open community <ArrowRight size={14} /></button>
        </div>
      ) : (
        <div className="space-y-3">
          <input value={title} onChange={(e) => setTitle(e.target.value)} data-testid="hearth-title-input" placeholder="Name your community (e.g. The Studio, Our Family)" className="w-full bg-[#1a1a1a] border border-white/10 text-white font-body text-sm px-3 py-2 outline-none" />
          <div className="flex gap-2">
            {[["invite", "Invite-only", "Invite any SovSig members you choose"], ["subscriber", "Open to subscribers", "Everyone who subscribes gets access"]].map(([v, label, desc]) => (
              <button key={v} onClick={() => setMode(v)} data-testid={`hearth-mode-${v}`} className={`flex-1 text-left border p-3 transition-colors ${mode === v ? "border-[#14A89A] bg-[#14A89A]/5" : "border-white/12 hover:bg-white/5"}`}>
                <div className="font-body text-sm text-white">{label}</div>
                <div className="font-body text-[11px] text-zinc-500 mt-0.5">{desc}</div>
              </button>
            ))}
          </div>
          {mode === "subscriber" && <p className="font-body text-[11px] text-amber-400/70">Subscriber auto-join activates once paid subscriptions launch, for now you can invite people directly either way.</p>}
          <p className="font-body text-[11px] text-zinc-600">Transparency: community content is private to members. The Council can view it only if something is flagged for safety, never casually. Truly private 1:1 chats live in Exchanges.</p>
          <button onClick={save} disabled={busy} data-testid="enable-hearth" className="bg-[#14A89A] text-[#0A0A0A] font-semibold px-4 py-2 font-body text-sm disabled:opacity-50 flex items-center gap-1.5">{busy ? <Loader2 size={14} className="animate-spin" /> : <Lock size={14} />} Turn on community</button>
        </div>
      )}
    </div>
  );
};

export default BeaconHearthPanel;
